import { useEffect, useState } from 'react';
import { useAuth } from '../../context/AuthContext';
import DataTable from 'react-data-table-component';
import { FaFileInvoiceDollar, FaMinus, FaPlus, FaSave, FaSearch, FaUserFriends } from 'react-icons/fa';
import { MdDelete, MdEdit, MdClose } from 'react-icons/md';
import styles from "./metas.module.css";
import { api } from '../../utils/services/api';
import Swal from 'sweetalert2';
import WindowLayout from '../../utils/layout/windowsLayout';
import Select from 'react-select';
import { APP_OPTIONS, SERVICE } from '../../utils/constants/services';
import { IoMdPrint } from 'react-icons/io';
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs';
import 'react-tabs/style/react-tabs.css';
import { PiNewspaperClippingFill } from 'react-icons/pi';
import { Button, Modal } from 'react-bootstrap';
import { downloadPDFFromBase64, isMobileDevice, openPDFInNewWindow } from '../../utils/downloadUtils';

const customStyles = {
    headRow: {
        style: {
            minHeight: "40px",
            backgroundColor: "#046cc2",
            fontSize: "15px",
            color: "white",
        },
    },


};
export default function Metas(props) {
    const { windowSize, userId, setMenuActual } = useAuth();

    const [sucursales, setSucursales] = useState([]);
    const [sucursalSelect, setSucursalSelect] = useState(null);

    const [meses, setMeses] = useState([]);
    const [mesSelect, setMesSelect] = useState(null);

    const [years, setYears] = useState([]);
    const [yearSelect, setYearSelect] = useState(null);

    const [semanas, setSemanas] = useState([]);
    const [semanaSelect, setSemanaSelect] = useState(null);

    const [estatusSelect, setEstatusSelect] = useState("PEN");

    const [showMetaModal, setShowMetaModal] = useState(false);
    const [selectedMetaData, setSelectedMetaData] = useState(null);
    const [metaValue, setMetaValue] = useState('');

    const [showDetailModal, setShowDetailModal] = useState(false);
    const [selectedDetailData, setSelectedDetailData] = useState(null);


    const [fecha, setFecha] = useState(new Date().toLocaleDateString('es-MX', {
        year: 'numeric',
        month: '2-digit',
        day: '2-digit',
        timeZone: 'America/Mexico_City'
    }).split('/').reverse().join('-'));
    const [loading, setLoading] = useState(false);
    const [dataTable, setDataTable] = useState([]);
    const [dataTotals, setDataTotals] = useState({});
    const [tipo, setTipo] = useState(1);
    const [show, setShow] = useState(false);
    const [loadingPrint, setLoadingPrint] = useState(false);
    const [loadingPrint2, setLoadingPrint2] = useState(false);
    const baseColumns = [
        {
            name: '#',
            selector: row => row.rowNumber,
            width: "80px"
        },
        {
            name: 'Asesor',
            selector: row => row.advisorName,
            wrap: true,
        },
        // {
        //     name: 'Sucursal',
        //     selector: row => sucursales.find(s => s.value === row.centralOfficeId)?.label || '',
        //     wrap: true,
        // }
    ];
    const columns2 = [
        {
            name: '#',
            selector: row => row.rowNumber,
            width: "80px"
        },
        {
            name: 'Asesor',
            selector: row => row.advisorName,
            wrap: true,
        },
        {
            name: 'Total Colocado',
            selector: row => row.dataMonthly && row.dataMonthly.amountTotal ? "$ " + row.dataMonthly.amountTotal.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : "$ 0.00",
            wrap: true,
        },
        {
            name: 'Meta Total (100%)',
            selector: row => row.dataMonthly && row.dataMonthly.amountGoals ? "$ " + row.dataMonthly.amountGoals.toLocaleString('es-MX', {
                minimumFractionDigits: 2,
                maximumFractionDigits: 2
            }) : "$ 0.00",
            wrap: true,
        },
        {
            name: 'Diferencia',
            selector: row => {
                const amount = row.dataMonthly && row.dataMonthly.amountDifference ? row.dataMonthly.amountDifference : 0;
                return amount;
            },
            width: "130px",
            center: true,
            cell: (row) => {
                const amount = row.dataMonthly && row.dataMonthly.amountDifference ? row.dataMonthly.amountDifference : 0;
                const isNegative = amount < 0;

                return (
                    <span style={{ color: isNegative ? 'red' : amount === 0 ? '' : 'green' }}>
                        $ {Math.abs(amount).toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </span>
                );
            }
        },
        {
            name: 'Porcentaje',
            selector: row => row.dataMonthly && row.dataMonthly.porcentGoal ? row.dataMonthly.porcentGoal : 0,
            width: "150px",
            center: true,
            cell: (row) => {
                const porcentaje = row.dataMonthly && row.dataMonthly.porcentGoal ? row.dataMonthly.porcentGoal : 0;

                let color = '#dc3545';
                let backgroundColor = '#f8d7da'; 

                if (porcentaje >= 100) {
                    color = '#28a745'; 
                    backgroundColor = '#d4edda'; 
                } else if (porcentaje >= 80) {
                    color = '#ffc107'; 
                    backgroundColor = '#fff3cd'; 
                } else if (porcentaje >= 60) {
                    color = '#fd7e14';
                    backgroundColor = '#ffeaa7'; 
                } else if (porcentaje >= 40) {
                    color = '#e83e8c'; 
                    backgroundColor = '#f8d7da'; 
                }

                return (
                    <span
                        style={{
                            color: color,
                            backgroundColor: backgroundColor,
                            padding: '4px 8px',
                            borderRadius: '4px',
                            fontWeight: 'bold',
                            fontSize: '12px'
                        }}
                    >
                        {porcentaje.toFixed(2)}%
                    </span>
                );
            }
        },
        {
            name: 'Siguiente Meta',

            width: "180px",
            center: true,
            cell: (row) => {
                const porcentajeActual = row.dataMonthly.porcentGoal || 0;
                const metaTotal = row.dataMonthly.amountGoals || 0;
                const colocadoActual = row.dataMonthly.amountTotal || 0;
                if (metaTotal === 0) {
                    return (
                        <span style={{
                            color: 'gray',
                            fontWeight: 'bold',
                            backgroundColor: '#e2e3e5',
                            padding: '4px 8px',
                            borderRadius: '4px'
                        }}>
                            N/A
                        </span>
                    );
                }
                if (porcentajeActual >= 100) {
                    return (
                        <span style={{
                            color: '#28a745',
                            fontWeight: 'bold',
                            backgroundColor: '#d4edda',
                            padding: '4px 8px',
                            borderRadius: '4px'
                        }}>
                            ✅ Meta alcanzada
                        </span>
                    );
                }

                let siguienteObjetivo = 50;
                if (porcentajeActual >= 90) {
                    siguienteObjetivo = 100;
                } else if (porcentajeActual >= 80) {
                    siguienteObjetivo = 90;
                } else if (porcentajeActual >= 70) {
                    siguienteObjetivo = 80;
                } else if (porcentajeActual >= 60) {
                    siguienteObjetivo = 70;
                } else if (porcentajeActual >= 50) {
                    siguienteObjetivo = 60;
                }

                const montoObjetivo = (metaTotal * siguienteObjetivo) / 100;
                const faltante = montoObjetivo - colocadoActual;

                let color = '#dc3545';
                let backgroundColor = '#f8d7da';

                if (siguienteObjetivo - porcentajeActual <= 10) {
                    color = '#28a745';
                    backgroundColor = '#d4edda';
                } else if (siguienteObjetivo - porcentajeActual <= 20) {
                    color = '#ffc107';
                    backgroundColor = '#fff3cd';
                }

                return (
                    <div style={{ textAlign: 'center' }}>
                        <div style={{
                            fontSize: '14px',
                            color: '#696969',
                            marginBottom: '2px'
                        }}>
                            Para <b>{siguienteObjetivo}%</b>:
                        </div>
                        <span style={{
                            color: color,
                            backgroundColor: backgroundColor,
                            padding: '2px 6px',
                            borderRadius: '3px',
                            fontWeight: 'bold',
                            fontSize: '13px',
                        }}>
                            ${Math.abs(faltante).toLocaleString('es-MX')}
                        </span>
                    </div>
                );
            }
        }
        // {
        //     name: 'Sucursal',
        //     selector: row => sucursales.find(s => s.value === row.centralOfficeId)?.label || '',
        //     wrap: true,
        // }
    ];
    const baseColumns2 = [
        {
            name: 'Total Colocado',
            selector: row => {
                if (!semanaSelect || !semanaSelect.fechaInicio) return 0;

                // Convertir fecha de inicio del select a formato YYYY-MM-DD
                const [dayI, monthI, yearI] = semanaSelect.fechaInicio.split('/');
                const fechaInicioKey = `${yearI}-${monthI}-${dayI}`;

                // Buscar en dataGoals el registro que coincida con la fecha de inicio
                const goalData = row.dataGoals?.find(goal => {
                    if (goal.startDate) {
                        const goalStartDate = goal.startDate.split('T')[0]; // "2025-09-08"
                        return goalStartDate === fechaInicioKey;
                    }
                    return false;
                });

                return goalData ? goalData.amountC : 0;
            },
            width: "150px",
            center: true,
            cell: (row) => {
                if (!semanaSelect || !semanaSelect.fechaInicio) return '$0';

                const [dayI, monthI, yearI] = semanaSelect.fechaInicio.split('/');
                const fechaInicioKey = `${yearI}-${monthI}-${dayI}`;

                const goalData = row.dataGoals?.find(goal => {
                    if (goal.startDate) {
                        const goalStartDate = goal.startDate.split('T')[0];
                        return goalStartDate === fechaInicioKey;
                    }
                    return false;
                });

                const amount = goalData ? goalData.amountC : 0;
                return `$${amount.toLocaleString('es-MX', {
                    minimumFractionDigits: 2,
                    maximumFractionDigits: 2
                })}`;
            }
        },
        {
            name: 'Meta',
            selector: row => {
                if (!semanaSelect || !semanaSelect.fechaInicio) return 0;

                const [dayI, monthI, yearI] = semanaSelect.fechaInicio.split('/');
                const fechaInicioKey = `${yearI}-${monthI}-${dayI}`;

                const goalData = row.dataGoals?.find(goal => {
                    if (goal.startDate) {
                        const goalStartDate = goal.startDate.split('T')[0];
                        return goalStartDate === fechaInicioKey;
                    }
                    return false;
                });

                return goalData ? goalData.amount : 0;
            },
            width: "120px",
            center: true,
            cell: (row) => {
                if (!semanaSelect || !semanaSelect.fechaInicio) return '$0';

                const [dayI, monthI, yearI] = semanaSelect.fechaInicio.split('/');
                const fechaInicioKey = `${yearI}-${monthI}-${dayI}`;

                const goalData = row.dataGoals?.find(goal => {
                    if (goal.startDate) {
                        const goalStartDate = goal.startDate.split('T')[0];
                        return goalStartDate === fechaInicioKey;
                    }
                    return false;
                });

                const amount = goalData ? goalData.amount : 0;
                return (
                    <div
                        className={styles.metaCell}
                        onClick={() => handleMetaCellClick(row, goalData)}
                        style={{ cursor: 'pointer' }}
                    >
                        {`$ ${amount.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}`}
                    </div>
                )
            }
        },
        {
            name: 'Diferencia',
            selector: row => {
                if (!semanaSelect || !semanaSelect.fechaInicio) return 0;

                const [dayI, monthI, yearI] = semanaSelect.fechaInicio.split('/');
                const fechaInicioKey = `${yearI}-${monthI}-${dayI}`;

                const goalData = row.dataGoals?.find(goal => {
                    if (goal.startDate) {
                        const goalStartDate = goal.startDate.split('T')[0];
                        return goalStartDate === fechaInicioKey;
                    }
                    return false;
                });

                return goalData ? goalData.amountDifference : 0;
            },
            width: "130px",
            center: true,
            cell: (row) => {
                if (!semanaSelect || !semanaSelect.fechaInicio) return '$0';

                const [dayI, monthI, yearI] = semanaSelect.fechaInicio.split('/');
                const fechaInicioKey = `${yearI}-${monthI}-${dayI}`;

                const goalData = row.dataGoals?.find(goal => {
                    if (goal.startDate) {
                        const goalStartDate = goal.startDate.split('T')[0];
                        return goalStartDate === fechaInicioKey;
                    }
                    return false;
                });

                const amount = goalData ? goalData.amountDifference : 0;
                const isNegative = amount < 0;

                return (
                    <span style={{ color: isNegative ? 'red' : amount === 0 ? '' : 'green' }}>
                        $ {Math.abs(amount).toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        })}
                    </span>
                );
            }
        }
    ];
    const [columns, setColumns] = useState(baseColumns);

    const handleMetaCellClick = (row, goalData) => {
        setSelectedMetaData({
            advisorName: row.advisorName,
            advisorId: row.advisorId,
            goalId: goalData?.id || null,
            currentAmount: goalData?.amount || 0
        });
        setMetaValue(goalData?.amount || 0);
        setShowMetaModal(true);
    };
    const handleCancelMeta = () => {
        setShowMetaModal(false);
        setSelectedMetaData(null);
        setMetaValue('');
    };

    const handleSaveMeta = () => {
        if (selectedMetaData) {
            if (metaValue === '' || isNaN(metaValue) || parseFloat(metaValue) <= 0) {
                Swal.fire({
                    title: 'Error',
                    text: 'Por favor, ingresa un valor numérico válido para la meta.',
                    icon: 'error',
                    showConfirmButton: true
                });
                return;
            }
            const payload = {
                advisorId: selectedMetaData.advisorId,
                amount: parseFloat(metaValue),
                startDate: semanaSelect ? convertDateFormat(semanaSelect.fechaInicio) : null,
                endDate: semanaSelect ? convertDateFormat(semanaSelect.fechaFin) : null,
                centralOfficeId: sucursalSelect ? sucursalSelect.value : null,
                userId: userId
            };
            let method = 'POST';
            let url = SERVICE.setMeta;
            if (selectedMetaData.goalId) {
                payload.id = selectedMetaData.goalId;
                method = 'PUT';
                url = SERVICE.updateMeta;
            }
            api(url, payload, method)
                .then((data) => {
                    Swal.fire({
                        title: 'Éxito',
                        text: 'La meta se ha guardado correctamente.',
                        icon: 'success',
                        showConfirmButton: false,
                        timer: 1500
                    });
                    handleUpdate();
                })
                .catch((err) => {
                    console.error('Error al guardar la meta:', err);
                    Swal.fire({
                        title: 'Error',
                        text: 'Hubo un error al guardar la meta. Por favor, inténtalo de nuevo.',
                        icon: 'error',
                        showConfirmButton: false,
                        timer: 1500
                    });
                });

        }

        setShowMetaModal(false);
    };
    const generateDynamicColumns = (fechaInicio, fechaFin) => {
        const [dayI, monthI, yearI] = fechaInicio.split('/');
        const [dayF, monthF, yearF] = fechaFin.split('/');

        const startDate = new Date(yearI, monthI - 1, dayI);
        const endDate = new Date(yearF, monthF - 1, dayF);

        const dynamicColumns = [];
        const currentDate = new Date(startDate);

        // Generar columnas para cada día en el rango
        while (currentDate <= endDate) {

            const day = currentDate.getDate().toString().padStart(2, '0');
            const month = (currentDate.getMonth() + 1).toString().padStart(2, '0');
            const year = currentDate.getFullYear();
            const dateString = `${day}/${month}/${year}`;
            const dateKey = `${year}-${month}-${day}`;
            dynamicColumns.push({
                name: (
                    <div style={{ textAlign: 'center', lineHeight: '1.2' }}>
                        <div style={{ fontSize: '10px', fontWeight: 'normal', color: '#6c757d' }}>
                            {currentDate.toLocaleDateString('es-ES', { weekday: 'long' }).toUpperCase()}
                        </div>
                        <div style={{ fontSize: '12px', fontWeight: 'bold' }}>
                            {dateString}
                        </div>
                    </div>
                ),
                selector: row => {
                    const dayData = row.dataDiary.find(item => {
                        if (item.date) {
                            const itemDate = item.date.split('T')[0];
                            return itemDate === dateKey;
                        }
                        return false;
                    });

                    if (dayData && row.advisorId === dayData.advisorId) {
                        return dayData.amountTotal || 0;
                    }

                    return 0;
                },
                width: "120px",
                center: true,
                cell: (row) => {
                    const dayData = row.dataDiary.find(item => {
                        if (item.date) {
                            const itemDate = item.date.split('T')[0];
                            return itemDate === dateKey;
                        }
                        return false;
                    });

                    if (dayData && row.advisorId === dayData.advisorId) {
                        const hasDetails = dayData.details && dayData.details.length > 0;
                        const amount = dayData.amountTotal ? dayData.amountTotal.toLocaleString('es-MX', {
                            minimumFractionDigits: 2,
                            maximumFractionDigits: 2
                        }) : "0.00";
                        
                        return (
                            <span 
                                style={{ 
                                    cursor: hasDetails ? 'pointer' : 'default',
                                    color: hasDetails ? '#046cc2' : 'inherit',
                                    textDecoration: hasDetails ? 'underline' : 'none'
                                }}
                                onClick={() => hasDetails && handleDetailClick(dayData, dateString)}
                                title={hasDetails ? 'Ver detalles' : ''}
                            >
                                $ {amount}
                            </span>
                        );
                    }

                    return '$ 0.00';
                }
            });

            // Avanzar al siguiente día
            currentDate.setDate(currentDate.getDate() + 1);
        }

        return dynamicColumns;
    };
    const updateColumns = (semanaSelected) => {
        if (semanaSelected && semanaSelected.fechaInicio && semanaSelected.fechaFin) {
            const dynamicColumns = generateDynamicColumns(semanaSelected.fechaInicio, semanaSelected.fechaFin);
            const newColumns = [...baseColumns, ...dynamicColumns, ...baseColumns2];
            setColumns(newColumns);
        }
    };
    const handlesetYears = () => {
        const currentYear = new Date().getFullYear();
        let arrayTemp = [];
        for (let index = currentYear - 5; index <= currentYear + 5; index++) {
            arrayTemp.push({
                value: index,
                label: index
            });
            if (index === currentYear) {
                setYearSelect({
                    value: index,
                    label: index
                });
            }
        }
        setYears(arrayTemp);
    }
    const handlesetMeses = () => {
        const monthNames = [
            "ENERO", "FEBRERO", "MARZO", "ABRIL", "MAYO", "JUNIO",
            "JULIO", "AGOSTO", "SEPTIEMBRE", "OCTUBRE", "NOVIEMBRE", "DICIEMBRE"
        ];
        const currentMonth = new Date().getMonth() + 1;

        let arrayTemp = [];
        for (let index = 0; index < 12; index++) {
            const element = index + 1;
            arrayTemp.push({
                value: element,
                label: monthNames[index]
            });

            if (element === currentMonth) {
                setMesSelect({
                    value: element,
                    label: monthNames[index]
                });
            }
        }
        setMeses(arrayTemp);
    }
    const handleGetSemanas = (mes, año) => {
        let arrayTemp = [];
        const year = año;

        // Obtener el primer día del mes
        let currentDate = new Date(year, mes - 1, 1);

        let weekCounter = 1;
        let semanaActualEncontrada = false;
        const hoy = new Date();
        hoy.setHours(0, 0, 0, 0); // Normalizar la hora para comparación

        while (currentDate.getMonth() === mes - 1) {
            // Encontrar el lunes de la semana actual (o el primer día del mes si no es lunes)
            let fechaInicio = new Date(currentDate);

            // Si no estamos en lunes, retroceder al lunes anterior
            // Pero si es el primer día del mes, usar ese día como inicio
            if (fechaInicio.getDate() === 1) {
                // Si el mes empieza en un día que no es lunes, usar ese día como inicio
                // No retroceder al mes anterior
            } else {
                // Para las siguientes semanas, encontrar el lunes
                while (fechaInicio.getDay() !== 1) { // 1 = lunes
                    fechaInicio.setDate(fechaInicio.getDate() - 1);
                    // Si retrocedemos al mes anterior, usar el primer día del mes actual
                    if (fechaInicio.getMonth() !== mes - 1) {
                        fechaInicio = new Date(year, mes - 1, 1);
                        break;
                    }
                }
            }

            // Fecha de fin (viernes de la misma semana o último día del mes)
            let fechaFin = new Date(fechaInicio);

            // Avanzar hasta el viernes (día 5) o hasta que se acabe el mes
            while (fechaFin.getDay() !== 5 && fechaFin.getMonth() === mes - 1) {
                fechaFin.setDate(fechaFin.getDate() + 1);
            }

            // Si nos pasamos del mes, retroceder al último día del mes
            if (fechaFin.getMonth() !== mes - 1) {
                fechaFin = new Date(year, mes, 0); // Último día del mes
            }

            // Formatear fechas como DD/MM/YYYY
            const formatDate = (date) => {
                const day = date.getDate().toString().padStart(2, '0');
                const month = (date.getMonth() + 1).toString().padStart(2, '0');
                const year = date.getFullYear();
                return `${day}/${month}/${year}`;
            };

            const fechaInicioStr = formatDate(fechaInicio);
            const fechaFinStr = formatDate(fechaFin);

            // Si fechaInicio y fechaFin son iguales, mostrar solo una fecha
            const label = fechaInicioStr === fechaFinStr
                ? fechaInicioStr
                : `${fechaInicioStr} - ${fechaFinStr}`;

            const semanaObj = {
                value: weekCounter,
                fechaInicio: fechaInicioStr,
                fechaFin: fechaFinStr,
                label: label
            };

            arrayTemp.push(semanaObj);

            // Verificar si la fecha actual está en este rango
            if (!semanaActualEncontrada && hoy >= fechaInicio && hoy <= fechaFin) {
                setSemanaSelect(semanaObj);
                semanaActualEncontrada = true;
            }

            // Avanzar al siguiente lunes o al siguiente día después del viernes
            currentDate = new Date(fechaFin);
            currentDate.setDate(currentDate.getDate() + 1);

            // Avanzar hasta el siguiente lunes (si no estamos ya en uno)
            while (currentDate.getDay() !== 1 && currentDate.getMonth() === mes - 1) {
                currentDate.setDate(currentDate.getDate() + 1);
            }

            weekCounter++;

            // Si ya no hay más lunes en el mes, salir del bucle
            if (currentDate.getMonth() !== mes - 1) {
                break;
            }
        }

        setSemanas(arrayTemp);

        if (!semanaActualEncontrada && arrayTemp.length > 0) {
            setSemanaSelect(arrayTemp[0]);
        }
    }

    const convertDateFormat = (dateStr) => {
        const [day, month, year] = dateStr.split('/');
        return `${year}-${month}-${day}`;
    };
    const handleUpdate = () => {
        if (semanaSelect && sucursalSelect != null) {
            setLoading(true);
            const fechaInicioFormatted = convertDateFormat(semanaSelect.fechaInicio);
            const fechaFinFormatted = convertDateFormat(semanaSelect.fechaFin);


            api(SERVICE.getInfoMetas + `?dateS=${fechaInicioFormatted}&dateE=${fechaFinFormatted}&centralOfficeId[0]=${sucursalSelect.value}`)
                .then((data) => {

                    if (data.data) {
                        const info = data.data;
                        let arrayTemp = [];
                        for (let index = 0; index < info.length; index++) {
                            const element = info[index];
                            arrayTemp.push({
                                ...element,
                                rowNumber: index + 1
                            });
                        }
                        setDataTable(arrayTemp);
                    }
                    else {
                        setDataTable([]);
                    }
                })
                .catch((err) => {
                    console.log(err);
                })
                .finally(() => {
                    setLoading(false);
                })
        }
        else {
            setDataTable([]);
        }
    }
    const handleGetSucursales = () => {
        api(SERVICE.getOfices)
            .then((data) => {
                let arrayTemp = [];
                if (data.data.data) {
                    for (let index = 0; index < data.data.data.length; index++) {
                        const element = data.data.data[index];
                        arrayTemp.push({
                            value: element.id,
                            label: element.description
                        });

                    }
                }
                setSucursales(arrayTemp);
            })
            .catch((err) => {
                console.log(err);
            })
    }

    const handleGenerateMonthlyReport = () => {
        if (!semanas || semanas.length === 0 || !sucursalSelect) {
            Swal.fire({
                title: 'Error',
                text: 'Seleccione una sucursal y asegúrese de que haya semanas disponibles.',
                icon: 'error',
                showConfirmButton: true
            });
            return;
        }

        const weeks = semanas.map(semana => {
            const start = convertDateFormat(semana.fechaInicio);
            const end = convertDateFormat(semana.fechaFin);
            return `${start}@${end}`;
        });

        const centralOfficeIds = [sucursalSelect.value];

        const weeksParams = weeks.map((week, index) => `Weeks[${index}]=${encodeURIComponent(week)}`).join('&');
        const centralOfficeParams = centralOfficeIds.map((id, index) => `centralOfficeId[${index}]=${encodeURIComponent(id)}`).join('&');
        
        const url = `${SERVICE.getReportPDFGoals}?${weeksParams}&${centralOfficeParams}`;

        setLoadingPrint(true);
        api(url, {}, 'GET')
            .then(response => {
                if (response.data.data) {
                    const fileName = `Reporte_Metas_${mesSelect.label}_${yearSelect.value}_${sucursalSelect.label}.pdf`;
                    
                    const success = downloadPDFFromBase64(response.data.data, fileName);

                    if (!success && isMobileDevice()) {
                        openPDFInNewWindow(response.data.data);
                    }
                } else {
                    throw new Error('No se recibió el archivo.');
                }
            })
            .catch(err => {
                console.error('Error al generar el reporte:', err);
                Swal.fire({
                    title: 'Error',
                    text: 'Hubo un problema al generar el reporte. Inténtelo de nuevo.',
                    icon: 'error',
                    showConfirmButton: true
                });
            })
            .finally(() => setLoadingPrint(false));
    };

    useEffect(() => {
        handleGetSucursales();
        handlesetMeses();
        handlesetYears();
    }, [])
    useEffect(() => {
        if (mesSelect != null && yearSelect != null) {
            handleGetSemanas(mesSelect.value, yearSelect.value);
        }
        else {
            setSemanas([]);
            setSemanaSelect(null);
        }
    }, [mesSelect, yearSelect])

    useEffect(() => {
        handleUpdate();
    }, [sucursalSelect, semanaSelect])
    useEffect(() => {
        updateColumns(semanaSelect);
    }, [semanaSelect, sucursales]);

    const handleSemanaChange = (selectedSemana) => {
        setSemanaSelect(selectedSemana);
        updateColumns(selectedSemana);
    };

    const handleDetailClick = (dayData, date) => {
        if (dayData && dayData.details && dayData.details.length > 0) {
            setSelectedDetailData({
                advisorName: dayData.advisorName,
                date: date,
                amountTotal: dayData.amountTotal,
                details: dayData.details
            });
            setShowDetailModal(true);
        }
    };

    const handleCloseDetailModal = () => {
        setShowDetailModal(false);
        setSelectedDetailData(null);
    };
    return (
        <>
            <WindowLayout
                title="METAS ASESORES"
                route={["Inicio", "Prestamos", "Metas Asesores"]}
                actions={[() => setMenuActual("homeMenu"), () => setMenuActual("prestamoMenu")]}
                icon={<PiNewspaperClippingFill />}
            >
                <div className='paperContainer'>
                    <div style={{ display: "flex", justifyContent: "left",flexWrap: "wrap" }}>
                        <div className={styles.itemForm} style={{ zIndex: 5 }}>
                            <label class="form-label">Sucursal: </label>
                            <Select isClearable={true} options={sucursales} class="form-control" placeholder="Seleccione..." value={sucursalSelect} onChange={(e) => setSucursalSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{zIndex: 4 }}>
                            <label class="form-label">Año: </label>
                            <Select isClearable={true} options={years} class="form-control" placeholder="Seleccione..." value={yearSelect} onChange={(e) => setYearSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{  zIndex: 3 }}>
                            <label class="form-label">Mes: </label>
                            <Select isClearable={true} options={meses} class="form-control" placeholder="Seleccione..." value={mesSelect} onChange={(e) => setMesSelect(e)} />
                        </div>
                        <div className={styles.itemForm} style={{  zIndex: 2 }}>
                            <label class="form-label">Semana: </label>
                            <Select isClearable={true} options={semanas} class="form-control" placeholder="Seleccione..." value={semanaSelect} onChange={handleSemanaChange} />
                        </div>
                    </div>
                    
                    <div style={{ display: "flex", justifyContent: "flex-end", marginBottom: "10px", marginTop: "15px" }}>
                        <button 
                            className='btn btn-primary' 
                            onClick={handleGenerateMonthlyReport} 
                            disabled={loadingPrint || !sucursalSelect || !mesSelect || !yearSelect || semanas.length === 0}
                        >
                            {loadingPrint ? (
                                <div class="spinner-border text-light spinner-border-sm" role="status">
                                    <span class="visually-hidden">Loading...</span>
                                </div>
                            ) : (
                                <>
                                    <IoMdPrint /> Generar Reporte del Mes
                                </>
                            )}
                        </button>
                    </div>

                    <div className={styles.conteMain}>
                        {
                            loading ?

                                <div className={styles.corteNoData}>
                                    <h5>Cargando...</h5>&nbsp;&nbsp;&nbsp;
                                    <div class="spinner-border text-primary" role="status">
                                        <span class="visually-hidden">Loading...</span>
                                    </div>
                                </div>
                                :
                                sucursalSelect === null || mesSelect === null || semanaSelect === null || yearSelect === null ?
                                    <div className={styles.corteNoData}>
                                        <h5>Seleccione una sucursal y una fecha para empezar.</h5>
                                    </div>
                                    :
                                    dataTable.length === 0 ?
                                        <div className={styles.corteNoData}>
                                            <h5>No se encontro información.</h5>
                                        </div>
                                        :
                                        <>
                                            <ul class="nav nav-tabs">
                                                <li className={estatusSelect === "PEN" ? "nav-item-active" : "nav-item"} onClick={() => setEstatusSelect("PEN")}>
                                                    <a className={estatusSelect === "PEN" ? "nav-link active" : "nav-link"}>Metas Semanales</a>
                                                </li>
                                                <li className={estatusSelect === "PAG" ? "nav-item-active" : "nav-item"} onClick={() => setEstatusSelect("PAG")}>
                                                    <a className={estatusSelect === "PAG" ? "nav-link active" : "nav-link"}>Metas Totales</a>
                                                </li>
                                            </ul>
                                            <div className={styles.tableContainer} style={{ width: "100%", display: !loading && dataTable.length > 0 ? estatusSelect === "PEN" ? "" : "none" : "none" }}>
                                                <DataTable
                                                    columns={columns}
                                                    data={dataTable}
                                                    customStyles={APP_OPTIONS.TABLE_SETTING_CORTE}
                                                    persistTableHead
                                                    fixedHeader
                                                    fixedHeaderScrollHeight="400px"
                                                    responsive
                                                />
                                            </div>
                                            <div className={styles.tableContainer} style={{ width: "100%", display: !loading && dataTable.length > 0 ? estatusSelect === "PAG" ? "" : "none" : "none" }}>
                                                <DataTable
                                                    columns={columns2}
                                                    data={dataTable}
                                                    customStyles={APP_OPTIONS.TABLE_SETTING_CORTE}
                                                    persistTableHead
                                                    fixedHeader
                                                    fixedHeaderScrollHeight="400px"
                                                    responsive
                                                />
                                            </div>
                                        </>
                        }

                    </div>



                </div>
                <Modal show={showMetaModal} onHide={handleCancelMeta} size="md" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Editar Meta</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        <div className="row">
                            <div className="col-12 mb-3">
                                <label className="form-label">Asesor:</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    value={selectedMetaData?.advisorName || ''}
                                    disabled
                                />
                            </div>
                            <div className="col-12 mb-3">
                                <label className="form-label">Meta:</label>
                                <input
                                    type="number"
                                    className="form-control"
                                    value={metaValue}
                                    onChange={(e) => setMetaValue(e.target.value)}
                                    placeholder="Ingrese el monto de la meta"
                                    step="0.01"
                                    min="0"
                                />
                            </div>
                        </div>
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCancelMeta}>
                            Cancelar
                        </Button>
                        <Button variant="primary" onClick={handleSaveMeta}>
                            Aceptar
                        </Button>
                    </Modal.Footer>
                </Modal>

                {/* Modal de detalles diarios */}
                <Modal show={showDetailModal} onHide={handleCloseDetailModal} size="xl" centered>
                    <Modal.Header closeButton>
                        <Modal.Title>Detalle de Préstamos</Modal.Title>
                    </Modal.Header>
                    <Modal.Body>
                        {selectedDetailData && (
                            <>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <strong>Asesor:</strong> {selectedDetailData.advisorName}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Fecha:</strong> {selectedDetailData.date}
                                    </div>
                                </div>
                                <div className="row mb-3">
                                    <div className="col-md-6">
                                        <strong>Total del día:</strong> $ {selectedDetailData.amountTotal?.toLocaleString('es-MX', {
                                            minimumFractionDigits: 2,
                                            maximumFractionDigits: 2
                                        }) || '0.00'}
                                    </div>
                                    <div className="col-md-6">
                                        <strong>Número de préstamos:</strong> {selectedDetailData.details?.length || 0}
                                    </div>
                                </div>
                                
                                <div className="table-responsive">
                                    <table className="table table-striped table-hover">
                                        <thead style={{ backgroundColor: '#046cc2', color: 'white' }}>
                                            <tr>
                                                <th style={{ fontSize: '14px' }}>#</th>
                                                <th style={{ fontSize: '14px' }}>Cliente</th>
                                                <th style={{ fontSize: '14px' }}></th>
                                                <th style={{ fontSize: '14px' }}>Monto</th>
                                                <th style={{ fontSize: '14px' }}>Total a Pagar</th>
                                                <th style={{ fontSize: '14px' }}>Fecha Inicio</th>
                                                <th style={{ fontSize: '14px' }}>Fecha Fin</th>
                                                <th style={{ fontSize: '14px' }}>Estado</th>
                                            </tr>
                                        </thead>
                                        <tbody>
                                            {selectedDetailData.details?.map((detail, index) => (
                                                <tr key={detail.id}>
                                                    <td>{index + 1}</td>
                                                    <td>{detail.clientName} </td>
                                                    <td>{detail.ciclo===1 ? <span className="badge bg-sm bg-success">Nuevo</span> : <span className="badge bg-warning">Renovado (ciclo {detail.ciclo})</span>}</td>
                                                    <td>
                                                        $ {detail.amount?.toLocaleString('es-MX', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) || '0.00'}
                                                    </td>
                                                    <td>
                                                        $ {detail.amountPayable?.toLocaleString('es-MX', {
                                                            minimumFractionDigits: 2,
                                                            maximumFractionDigits: 2
                                                        }) || '0.00'}
                                                    </td>
                                                    <td>
                                                        {detail.startDate ? new Date(detail.startDate).toLocaleDateString('es-MX') : '-'}
                                                    </td>
                                                    <td>
                                                        {detail.endDate ? new Date(detail.endDate).toLocaleDateString('es-MX') : '-'}
                                                    </td>
                                                    <td>
                                                        <span 
                                                            className={`badge ${detail.status === 'ACTIVO' ? 'bg-success' : 
                                                                detail.status === 'PENDIENTE' ? 'bg-warning' : 'bg-secondary'}`}
                                                        >
                                                            {detail.status}
                                                        </span>
                                                    </td>
                                                </tr>
                                            ))}
                                        </tbody>
                                    </table>
                                </div>
                            </>
                        )}
                    </Modal.Body>
                    <Modal.Footer>
                        <Button variant="secondary" onClick={handleCloseDetailModal}>
                            Cerrar
                        </Button>
                    </Modal.Footer>
                </Modal>
            </WindowLayout>
        </>
    );
}